<template>
  <div class="input-container">
    <label :for="componentID" class="label">
      {{ label }} {{ inputType === "date" ? ": дд-мм-гггг" : null }}
      <asterisk v-if="isRequired" />
    </label>
    <date-picker
      v-if="inputType === 'date'"
      :value="value"
      @input="$emit('input', $event)"
      :lang="$t('short lang')"
      value-type="format"
      :editable="true"
      :clearable="!isRequired"
      :placeholder="$t('select date range')"
      format="DD-MM-YYYY"
      :not-after="maxDate"
      :not-before="minDate"
    />
    <input
      v-else
      :value="value"
      :disabled="disabled"
      @input="$emit('input', $event.target.value)"
      class="input"
      :type="inputType"
      :placeholder="inputPlaceholder"
      :id="componentID"
      :step="steps"
      :min="min_max_number.min"
      :max="min_max_number.max"
      :required="isRequired"
      :maxlength="inputMaxLength"
    />
  </div>
</template>

<script>
import Asterisk from "@/components/register/Asterisk";
import DatePicker from "vue2-datepicker";

export default {
  props: {
    componentID: {
      type: String,
      required: true
    },
    label: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inputType: {
      type: String,
      default: "text"
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    inputPlaceholder: {
      type: String,
      default: ""
    },
    inputMaxLength: {
      type: Number,
      default: null
    },
    steps: {
      type: Number,
      default: 1
    },
    minDate: {
      type: Date || null,
      default: null
    },
    maxDate: {
      type: Date || null,
      default: null
    },
    min_max_number: {
      type: Object,
      default() {
        return {
          min: null,
          max: null
        };
      }
    },
    value: {
      type: String
    }
  },
  model: {
    prop: "value",
    event: "input"
  },
  methods: {},
  components: {
    asterisk: Asterisk,
    "date-picker": DatePicker
  }
};
</script>

<style scoped>
.red {
  color: red;
}

.input-container {
  display: flex;
  flex-direction: column;
  color: #ffffff;
}

.label {
  margin-bottom: 10px;
  font-size: 15px;
}

.input {
  padding: 10px 15px;
  border-radius: 5px;
  outline: none;
  border: none;
  box-sizing: border-box;
}

.input:disabled {
  background-color: rgba(0, 0, 0, 0.1);
}

.input[type="number"]::-webkit-inner-spin-button,
.input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  margin: 0 !important;
}
</style>
